import { unref as v, getCurrentScope as j, onScopeDispose as O, onMounted as S, nextTick as x, getCurrentInstance as D, isRef as P, toRef as R, readonly as C, ref as F, customRef as A } from "vue";
function V(e) {
  return j() ? (O(e), !0) : !1;
}
function p(e) {
  return typeof e == "function" ? e() : v(e);
}
const I = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const E = (e) => e != null, M = Object.prototype.toString, H = (e) => M.call(e) === "[object Object]", c = () => {
}, N = /* @__PURE__ */ W();
function W() {
  var e, t;
  return I && ((e = window?.navigator) == null ? void 0 : e.userAgent) && (/iP(?:ad|hone|od)/.test(window.navigator.userAgent) || ((t = window?.navigator) == null ? void 0 : t.maxTouchPoints) > 2 && /iPad|Macintosh/.test(window?.navigator.userAgent));
}
function y(e, t) {
  function n(...o) {
    return new Promise((i, r) => {
      Promise.resolve(e(() => t.apply(this, o), { fn: t, thisArg: this, args: o })).then(i).catch(r);
    });
  }
  return n;
}
function k(e, t = {}) {
  let n, o, i = c;
  const r = (u) => {
    clearTimeout(u), i(), i = c;
  };
  return (u) => {
    const s = p(e), l = p(t.maxWait);
    return n && r(n), s <= 0 || l !== void 0 && l <= 0 ? (o && (r(o), o = null), Promise.resolve(u())) : new Promise((a, w) => {
      i = t.rejectOnCancel ? w : a, l && !o && (o = setTimeout(() => {
        n && r(n), o = null, a(u());
      }, l)), n = setTimeout(() => {
        o && r(o), o = null, a(u());
      }, s);
    });
  };
}
function _(...e) {
  let t = 0, n, o = !0, i = c, r, f, u, s, l;
  !P(e[0]) && typeof e[0] == "object" ? { delay: f, trailing: u = !0, leading: s = !0, rejectOnCancel: l = !1 } = e[0] : [f, u = !0, s = !0, l = !1] = e;
  const a = () => {
    n && (clearTimeout(n), n = void 0, i(), i = c);
  };
  return (T) => {
    const d = p(f), g = Date.now() - t, m = () => r = T();
    return a(), d <= 0 ? (t = Date.now(), m()) : (g > d && (s || !o) ? (t = Date.now(), m()) : u && (r = new Promise((h, b) => {
      i = l ? b : h, n = setTimeout(() => {
        t = Date.now(), o = !0, h(m()), a();
      }, Math.max(0, d - g));
    })), !s && !n && (n = setTimeout(() => o = !0, d)), o = !1, r);
  };
}
const $ = {
  mounted: "mounted",
  unmounted: "unmounted"
};
function G(e) {
  return D();
}
function q(...e) {
  if (e.length !== 1)
    return R(...e);
  const t = e[0];
  return typeof t == "function" ? C(A(() => ({ get: t, set: c }))) : F(t);
}
function z(e, t = 200, n = {}) {
  return y(
    k(t, n),
    e
  );
}
function B(e, t = 200, n = !1, o = !0, i = !1) {
  return y(
    _(t, n, o, i),
    e
  );
}
function J(e, t = !0, n) {
  G() ? S(e, n) : t ? e() : x(e);
}
export {
  I as a,
  H as b,
  V as c,
  $ as d,
  q as e,
  J as f,
  B as g,
  E as h,
  N as i,
  c as n,
  p as t,
  z as u
};
